import isEmpty from 'lodash/isEmpty';

export const getLocalStorage = () => {
  if (typeof window === "object") {
    return window.localStorage;
  } else {
    return {
      setItem: () => {},
      getItem: () => {}
    }
  }
}

export const mergeItem = (key, value) => {
  try {
    if (typeof window === "object" && window.localStorage) {
      let obj = JSON.parse(window.localStorage.getItem(key));
      if (isEmpty(obj)) {
        obj = {};
      }
      const mergedObj = {...obj, ...JSON.parse(value)}
      return window.localStorage.setItem(key, JSON.stringify(mergedObj));
    }
  } catch (error) {
    return null
  }
}

export const getItem = (key) => {
  try {
    if (typeof window === "object" && window.localStorage) {
      return window.localStorage.getItem(key);
    }
  } catch (error) {
    return null;
  }
}

export const setItem = (key, value) => {
  try {
    if (typeof window === "object" && window.localStorage) {
      return window.localStorage.setItem(key, value);
    }
  } catch (error) {
    return null;
  }
}

export const removeItem = (key, value) => {
  try {
    if (typeof window === "object" && window.localStorage) {
      return window.localStorage.removeItem(key, value);
    }
  } catch (error) {
    return null;
  }
}
